import React, { useState } from 'react';
import {
  Button,
  Checkbox,
  Chip,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  Icon,
  IconButton,
  Typography
} from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { useSelector } from 'react-redux';


const defaultCustomerGroups = [
  {
    id: 1,
    code: 'General'
  }
];

const kindOfStatuses = [
  {
    id: 0,
    accessType: 'no_access',
    accessLabel: 'No Access'
  },
  {
    id: 1,
    accessType: 'access_restricted',
    accessLabel: 'No Access (restricted)'
  },
  {
    id: 2,
    accessType: 'access_granted',
    accessLabel: 'Access Granted'
  },
  {
    id: 3,
    accessType: 'access_requested',
    accessLabel: 'Access Requested'
  },
];

const FilterDrawer = (
  {setOpenFilter, setFilterConditions, filterConditions}: IFilterDrawerProps
) => {
  const { customerGroups } = useSelector(
    (state: {customers: ICustomersState}) => state.customers
  );
  const [expandedGroup, toggleExpandedGroup] = useState(false);
  const [expandedAccessStatus, toogleExpandedAccessStatus] = useState(false);
  const [conditions, setConditions] = useState({
    group_id: {
      field: 'group_id',
      value: filterConditions.group_id?.value || '',
      conditionType: 'in'
    },
    request_access: {
      field: 'request_access',
      value: filterConditions.request_access?.value || '',
      conditionType: 'in'
    }
  });

  const handleChangeFilter = (field, value, conditionType, name) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: {
          field,
          value,
          conditionType
        }
      }
    ));
  };

  const handleApplyFilter = () => {
    setFilterConditions(conditions);
    setOpenFilter(false);
  };


  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div className="flex items-center flex-wrap mb-2">
          {Object.values(conditions).map((filterItem, index) => {
            if (!filterItem.value) {
              return null;
            }

            const label = filterItem.value.replace(/%/g, '');
            const fieldName = filterItem.field;

            if (filterItem.field === 'group_id') {
              const groupsIdsSelected = filterItem.value.length ? filterItem.value.split(',') : [];

              return (
                <>
                  {groupsIdsSelected.map((groupId) => {
                    const code = [...defaultCustomerGroups, ...customerGroups]
                      .find((group) => group.id == groupId)?.code;

                    if (!code) {
                      return null;
                    }

                    return (
                      <div key={`filter-group-${groupId}`} className="mr-2 mb-2">
                        <Chip
                          label={code}
                          onDelete={() => {
                            setConditions({
                              ...conditions,
                              group_id: {
                                ...conditions.group_id,
                                value: groupsIdsSelected.filter((id) => id != groupId).join(',')
                              }
                            }
                            );
                          }}
                        />
                      </div>
                    );
                  })
                  }
                </>
              );
            }

            if (filterItem.field === 'request_access') {
              const accessTypesSelected = filterItem.value.length ? filterItem.value.split(',') : [];
              return (
                <>
                  {accessTypesSelected.map((accessType) => {
                    if (!accessType) {
                      return null;
                    }

                    const status = kindOfStatuses.find((item) => item.accessType === accessType);

                    return (
                      <div key={`filter-group-${accessType}`} className="mr-2 mb-2">
                        <Chip
                          label={status.accessLabel}
                          onDelete={() => {
                            setConditions({
                              ...conditions,
                              request_access: {
                                ...conditions.request_access,
                                value: accessTypesSelected.filter((request_access) => request_access != accessType).join(',')
                              }
                            }
                            );
                          }}
                        />
                      </div>
                    );
                  })
                  }
                </>
              );
            }


            return (
              <div key={`filter-${index}`} className="mr-2 mb-2">
                <Chip
                  label={label}
                  onDelete={() => {
                    setConditions({
                      ...conditions,
                      [fieldName]: {
                        ...conditions[fieldName],
                        value: ''
                      }
                    });
                  }}
                />
              </div>
            );
          })}
        </div>
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toggleExpandedGroup((expandedGroup) => !expandedGroup)}
        >
          <Typography variant="h6">Customer Group</Typography>
          {expandedGroup ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedGroup} timeout="auto">
          <FormControl component="div">
            {[...defaultCustomerGroups, ...customerGroups].map((group) => (
              <FormControlLabel
                key={`customer-group-${group.id}`}
                value={group.id}
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={conditions.group_id.value.split(',').some((value) => +value === group.id)}
                    onChange={({target: {checked}}) => {
                      const groupIdsSelected = conditions.group_id.value.length
                        ? conditions.group_id.value.split(',')
                        : [];

                      const value = checked
                        ? [...groupIdsSelected, group.id].join(',')
                        : groupIdsSelected.filter((id) => id != group.id).join(',');

                      handleChangeFilter('group_id', value, 'in', 'group_id');
                    }}
                  />
                }
                label={group.code}
              />
            ))}
          </FormControl>
        </Collapse>
        <Divider className="my-5" />
        <div
          className="flex items-center justify-between cursor-pointer"
          onClick={() => toogleExpandedAccessStatus((expandedAccessStatus) => !expandedAccessStatus)}
        >
          <Typography variant="h6">Request Access Status</Typography>
          {expandedAccessStatus ? <ExpandLess /> : <ExpandMore />}
        </div>
        <Collapse in={expandedAccessStatus} timeout="auto">
          <FormControl component="div">
            {kindOfStatuses.map((status) => (
              <FormControlLabel
                key={`request-status-${status.id}`}
                value={status.accessType}
                control={
                  <Checkbox
                    color="primary"
                    size="small"
                    checked={conditions.request_access.value.split(',').some((value) => value === status.accessType)}
                    onChange={({target: {checked}}) => {
                      const accessTypesSelected = conditions.request_access.value.length
                        ? conditions.request_access.value.split(',')
                        : [];

                      const value = checked
                        ? [...accessTypesSelected, status.accessType].join(',')
                        : accessTypesSelected.filter((id) => id != status.accessType).join(',');

                      handleChangeFilter('request_access', value, 'in', 'request_access');
                    }}
                  />
                }
                label={status.accessLabel}
              />
            ))}
          </FormControl>
        </Collapse>
        <Divider className="my-5" />
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default FilterDrawer;
